import { createAction, props } from '@ngrx/store';
import {
  PresenceType,
  Reason,
  AppointmentState,
  Version,
  MhDepartment,
  MhStock,
  Firm,
  Initialization,
  Location,
  PersonConfigDto,
  HexAdministration,
  HexServingMode,
  AnimalType,
  SpeciesDiagnosesMappedDto,
  TimeRangeConfig,
  IsoCountry,
  Location as AppLocation,
  BookSetting,
  Department,
  Translation,
  CustomerExternalNumber,
  AnimalExternalNumber,
  AnimalDateType,
  CustomerCategoryGroup,
  CustomerCategory
} from 'src/app/api/models';
import { RgTextList } from 'src/app/medical-history/models/rg-text-list.model';
import { ConfigurationType } from 'src/app/settings/enums/configuration-type.enum';

export const loadStaticData = createAction(
  '[Static Data/API] Load Static Data'
);
export const loadStaticDataSuccess = createAction(
  '[Static Data/API] Load Static Data Success',
  props<{ reasons: Reason[], presenceTypes: PresenceType[], appointmentStates: AppointmentState[], userConfig: PersonConfigDto, timeRangeConfigs: TimeRangeConfig[] }>()
);

export const loadMedicalHistoryData = createAction(
  '[Static Data/API] Load Medical History Data',

);
export const loadMedicalHistoryDataSuccess = createAction(
  '[Static Data/API] Load Medical History Data Success',
  props<{ departments: MhDepartment[], inventoryList: MhStock[], firms: Firm[], mhInitialization: Initialization | undefined }>()
);

export const loadHexData = createAction(
  '[Static Data/API] Load Load Hex Data'
);
export const loadHexDataSuccess = createAction(
  '[Static Data/API]  Load Load Hex Data Success',
  props<{ applicationTypes: HexAdministration[], servingModes: HexServingMode[] | undefined }>()
);


export const updateMhInitializationItems = createAction(
  '[Items] Update items',
  props<{ newMhInitializationItems: Initialization }>()
);

export const loadVersion = createAction(
  '[Static Data/API] Load Version'
);
export const loadVersionSuccess = createAction(
  '[Static Data/API] Load Version Success',
  props<{ version: Version }>()
);

export const loadServiceArticleTreatmentData = createAction(
  '[Static Data/API] Load Service Article Treatment Data'
);
export const loadServiceArticleTreatmentDataSuccess = createAction(
  '[Static Data/API] Load Service Article Treatment Data Success',
  props<{ serviceArticleTreatments: RgTextList[] }>()
);

export const loadAnimalTypes = createAction(
  '[Static Data/API] Load Animal Types'
);
export const loadAnimalTypesSuccess = createAction(
  '[Static Data/API] Load Animal Types Success',
  props<{ animalTypes: Array<AnimalType> }>()
);

export const loadSpeciesDiagnosisData = createAction(
  '[Static Data/API] Load Species Diagnoses Data'
);
export const loadSpeciesDiagnosisDataSuccess = createAction(
  '[Static Data/API] Load Species Diagnoses Data Success',
  props<{ speciesDiagnoses: SpeciesDiagnosesMappedDto }>()
);

export const loadFirms = createAction(
  '[Static Data/API] Load firms'
);
export const loadFirmsSuccess = createAction(
  '[Static Data/API] Load firms Success',
  props<{ firms: Firm[] }>()
);

export const loadLocations = createAction(
  '[Static Data/API] Load Locations'
);
export const loadLocationsSuccess = createAction(
  '[Static Data/API] Load Locations Success',
  props<{ locations: Location[] }>()
);

export const loadCountryList = createAction(
  '[Static Data/API] Load Country List'
);
export const loadCountryListSuccess = createAction(
  '[Static Data/API] Load Country List Success',
  props<{ countryList: Array<IsoCountry> }>()
);

export const loadCountyList = createAction(
  '[Static Data/API] Load County List'
);
export const loadCountyListSuccess = createAction(
  '[Static Data/API] Load County List Success',
  props<{ countyList: Array<string> }>()
);

export const updateLocation = createAction(
  '[User/API] Update Location Name',
  props<{ location: AppLocation }>()
);
export const removeLocation = createAction(
  '[User/API] Remove Location',
  props<{ location: AppLocation }>()
);
export const updateBookSettings = createAction(
  '[User/API] Update Book Settings',
  props<{ bookSettings: BookSetting }>()
);

export const updateAddress = createAction(
  '[User/API] Update Address',
  props<{ entityId: string, addressId: string | undefined, typeEntity: ConfigurationType }>()
);
export const loadBookSettingList = createAction(
  '[Static Data/API] Load County List'
);
export const loadBookSettingListSuccess = createAction(
  '[Static Data/API] Load Book List Success',
  props<{ bookSettingList: Array<BookSetting> }>()
);

export const updateDepartmentSettings = createAction(
  '[User/API] Update Department Settings',
  props<{ departmentSettings: Department }>()
);
export const clearSettingsData = createAction(
  '[Static Data] Clear Settings Data'
);

export const loadTranslations = createAction(
  '[Static Data/API] Load Translations',
  props<{ keys: Array<string> }>()
);
export const loadTranslationsSuccess = createAction(
  '[Static Data/API] Load Translations Success',
  props<{ translations: Array<Translation> }>()
);

export const initServiceArticleTreatment = createAction(
  '[Book/API] Init Service Article treatment'
);
export const initMedicalHistory = createAction(
  '[Book/API] Init Medical History'
);
export const initSpeciesDiagnosisData = createAction(
  '[Static Data/API] Init Species Diagnoses Data'
);
export const initHexData = createAction(
  '[Static Data/API] Init Load Hex Data'
);

export const initCountryList = createAction(
  '[Book/API] Init Country list'
);
export const initCountyList = createAction(
  '[Book/API] Init County list'
);
export const initBookSettings = createAction(
  '[Book/API] Init Book Settings'
);

export const loadCustomerExternalNumbersData = createAction(
  '[Static Data/API] Load Customer External Numbers Data'
);
export const loadCustomerExternalNumbersDataSuccess = createAction(
  '[Static Data/API] Load Customer External Numbers Success',
  props<{ customerExternalNumbers: CustomerExternalNumber[] }>()
);

export const initCustomerExternalNumbersData = createAction(
  '[Book/API] Init Customer External Numbers'
);

export const loadAnimalExternalNumbersData = createAction(
  '[Static Data/API] Load Animal External Numbers Data'
);
export const loadAnimalExternalNumbersDataSuccess = createAction(
  '[Static Data/API] Load Animal External Numbers Success',
  props<{ animalExternalNumbers: AnimalExternalNumber[] }>()
);

export const initAnimalExternalNumbersData = createAction(
  '[Book/API] Init Animal external Numbers '
);

export const loadAnimalDateTypesData = createAction(
  '[Static Data/API] Load Animal Date Types'
);
export const loadAnimalDateTypesDataSuccess = createAction(
  '[Static Data/API] Load Animal Date Types Success',
  props<{ animalDateTypes: AnimalDateType[] }>()
);

export const initAnimalDateTypesData = createAction(
  '[Book/API] Init Animal Date Types'
);

export const loadCustomerCategoryGroupData = createAction(
  '[Static Data/API] Load Customer Category Group'
);

export const loadCustomerCategoryGroupDataSuccess = createAction(
  '[Static Data/API] Load Customer Category Group Success',
  props<{ customerCategoryGroup: CustomerCategoryGroup[] }>()
);

export const initCustomerCategoryGroupData = createAction(
  '[Book/API] Init Customer Category Group'
);
export const loadCustomerCategoryData = createAction(
  '[Static Data/API] Load Customer Category'
);

export const loadCustomerCategoryDataSuccess = createAction(
  '[Static Data/API] Load Customer Category Success',
  props<{ customerCategory: CustomerCategory[] }>()
);

export const initCustomerCategoryData = createAction(
  '[Book/API] Init Customer Category'
);